import request from "@/utils/request.js";

// 获取供应商列表
export function getMaterialSupplierList(query){
    return request({
        url:"/material/materialapp/api/admin/materialSupplier/list",
        method:"POST",
        ...query
    })
}

// 获取映射关系列表
export function getTemplateList(query){
    return request({
        url:"/material/materialapp/api/admin/materialRelationship/list",
        method:"POST",
        ...query
    })
}

// 导入领料任务
export function importMaterialTask(query){
    return request({
        url:"/material/materialapp/api/admin/materialMession/import",
        method:"POST",
        ...query
    })
}

export function fileUpload(query){
    return request({
        url:"/file/sysFileInfo/upload",
        method:"POST",
        ...query
    })
}

// 校验领料任务
export function verifyMaterialTask(query){
    return request({
        url: "/material/materialapp/api/admin/materialMession/verifyImport",
        method: "POST",
        ...query
    })
}
